import React from "react";
import SvgIcon from "../../../parts/SvgIcon";
/**
 * 
 filters is an array like this: 
 filters= [
  {
    text: '',
    id:....,
  },
  ...
 ]
 */
const FilterChips = ({ filters, clearAllFilters, clearFilter }) => {
  return (
    <div className="filters-wrapper">
      {filters.map((filter) => (
        <div className="filter-item" key={filter.id}>
          {filter.text}{" "}
          <SvgIcon
            src={"/img/new-icons/red-cross-20px.svg"}
            onClickFn={() => clearFilter(filter.id)}
            noFilterOnLight={true}
          />
        </div>
      ))}
      {clearAllFilters && filters.length > 0 && (
        <button data-button-type="secondary" data-action="cancel">
          Clear All
          <SvgIcon
            src={"/img/new-icons/red-cross-20px.svg"}
            onClickFn={clearAllFilters}
            noFilterOnLight={true}
          />
        </button>
      )}
    </div>
  );
};

export default FilterChips;
